import React, { Component } from 'react';
import {Modal,Button} from 'react-bootstrap';
import {connect} from 'react-redux';
import __ from 'lodash';
import {cekCookies} from '../../../../actions';
import { CONFIG } from '../../../../config';
import Navbar from '../../navbar/Navbar';
import Sidebar from '../../sidebar/Sidebar';
import LoaderModal from '../../../modal/LoaderModal';
import accountManagement from '../../../../apis/accountManagement';
import DetailAktivtyHwGuru from '../../../../entity/DetailAktivtyHwGuru'

import Loader from '../../../Loader';
import { Card } from '@material-ui/core';


class AktivitasHw extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isFetching: false,
            loading: false,
            openModalDetail : false,
            judulHw : null,
            dataGuru : [],
            dataHw : [],
            dataSiswa : [],
            dataKelasParalel : []
        }
    }


    async componentDidMount() {
        document.title = "Aktivitas HW";
        this.setState({
            isFetching: true
        });
        await this.props.cekCookies();

        if(!__.isEmpty(this.props.account)) {
            this.fetchHwGuruSekolah();
        }       

        this.setState({
            isFetching: false
        });
    }

    fetchHwGuruSekolah = async () =>{
        this.setState({loading: true});

        //fetch hw yg di bikin guru sekolah nya
        const resData = await accountManagement.get(CONFIG.FETCH_HW_GURU_SEKOLAH).catch(function(error){
        })
        if(resData){
            if(resData.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    dataHw: resData.data.data.dataHw,
                    dataGuru: resData.data.data.dataGuru,
                })
            }
        }
        this.setState({loading: false});
    }

    renderParent(){
        if(!__.isEmpty(this.state.dataGuru)){
            return this.state.dataGuru.map((val,i) => {
                return (

                    <div id="accordion"> 
                        <div className="card" style={{marginBottom: '5px'}} >
                            <div className="card-header">                    
                                <div className="row">
                                    <div className="col-sm-12 col-xs-12">
                                        <div className="row">
                                            <div className="col-sm-12 col-xs-12">
                                                <a className="card-link" data-toggle="collapse" href={'#child'+val.idGuru}>
                                                {val.namaGuru} <i className="fa fa-angle-down" aria-hidden="true" ></i>
                                                </a>
                                            </div>   
                                        </div>
                                    </div>
                                </div>
                            </div> 
                            { this.renderTableChild(val.idGuru, i) }                   
                        </div>   
                    </div>
                )
            })
        }
    }

    renderTableChild(id, i){
        return(
            <div id={'child'+id} class="panel-collapse collapse" data-parent="#accordion">
                <table class="table table">
                    <thead>
                        <tr>
                            <th key={i+1}>No</th>
                            <th key={i+2}>Jadwal</th>
                            <th key={i+3}>Mapel</th>
                            <th key={i+4}>Tgl Mulai</th>
                            <th key={i+5}>Tgl Selesai</th>
                            <th key={i+6}>Jumlah soal</th>
                            <th key={i+7}>Detail</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.renderChild(id)}
                    </tbody>
                </table>
            </div>
        )
    }


    renderChild(id){
        var n=1;
        if(!__.isEmpty(this.state.dataHw)){
            return this.state.dataHw.map((valChild,j) => {
                if(id===valChild.idGuru){
                    return (
                        <tr>
                            <td key={j+1}>{n++}</td>
                            <td key={j+2}>{valChild.namaJadwal}</td>
                            <td key={j+3}>{valChild.namaMapel}</td>
                            <td key={j+4}>{valChild.jadwalMulai}</td>
                            <td key={j+5}>{valChild.jadwalSelesai}</td>
                            <td key={j+6}>{valChild.jumSoal}</td>
                            <td key={j+7}>
                                <button className="btn btn-outline-primary" onClick={(e) => this.fetchDetailHw(valChild.idGuru, valChild.idProfilCbt, valChild.idJadwalProfil, valChild.namaJadwal)}>Lihat</button>
                            </td>
                        </tr>
                    )
                }                
            })
        }
    }


    fetchDetailHw = async(idGuru, idProfil, idJadwalProfil, namaJadwal) =>{
        console.log(idGuru);
        this.setState({
            isFetching : true,
            dataSiswa: [],
            dataKelasParalel: [],
            judulHw : namaJadwal
        })

        // cari siswa di kelas tersebut
        const resSiswaKelasParelel = await accountManagement.post(CONFIG.FETCH_DETAIL_HW_GURU,{...DetailAktivtyHwGuru,
            ['idGuru']: idGuru,
            ['idProfilCbt']: idProfil,
            ['idJadwalProfil']: idJadwalProfil,
        }).catch (function(error){
        })
        if(resSiswaKelasParelel){
            if(resSiswaKelasParelel.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    dataSiswa: resSiswaKelasParelel.data.data.dataSiswa,
                    dataKelasParalel: resSiswaKelasParelel.data.data.dataKp,
                })
            }
        }

        this.setState({
            isFetching: false,
            openModalDetail : true
        });
        console.log(this.state);
    }

    renderKelasParalel(){
        if(!__.isEmpty(this.state.dataKelasParalel)){            
            return this.state.dataKelasParalel.map((val,i) => {
                return (
                    <>
                    <div class="card">
                        <div class="card-header">
                            Kelas {val.namaKelasParalel}
                        </div>
                        <div class="card-body">
                            <table className="table table-sm table-striped table-hover">
                                <thead>
                                    <tr>
                                        <th>No</th>
                                        <th>Nama Siswa</th>
                                        <th style={{textAlign: '-webkit-center'}}>Jumlah Benar</th>
                                        <th style={{textAlign: '-webkit-center'}}>Jumlah Salah</th>
                                        <th style={{textAlign: '-webkit-center'}}>Skor</th>
                                        <th style={{textAlign: '-webkit-center'}}>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.renderSiswaKelasParalel(val.idKelasParalel)}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <br></br>
                  </>
                )
            })           
        }
    }

    renderSiswaKelasParalel(idKp){
        var n=1;
        if(!__.isEmpty(this.state.dataSiswa)){            
            return this.state.dataSiswa.map((val,ij) => {
                if(idKp == val.idKelasParalel){
                    return (
                        <tr>
                            <td key={ij+1}>{n++}</td>
                            <td key={ij+2}>{val.namaSiswa}</td>
                            <td key={ij+3} style={{textAlign: '-webkit-center'}}>{val.jumBenar}</td>
                            <td key={ij+4} style={{textAlign: '-webkit-center'}}>{val.jumSalah}</td>
                            <td key={ij+5} style={{textAlign: '-webkit-center'}}>{val.skor}</td>
                            <td key={ij+6} style={{textAlign: '-webkit-center'}}>
                                {
                                    val.status == 0 ? 
                                    <button className="btn btn-outline-danger" title="Belum mengumpulkan"><li className="fa fa-close"></li></button>
                                    : 
                                    <button className="btn btn-outline-info" title="Selesai"><li className="fa fa-check"></li></button>
                                }
                            </td>
                        </tr>    
                    )
                }
            })           
        }
    }

    renderModalDetail(){
        if(this.state.openModalDetail){
            return(
                <div className="modal fade show" id="modalLoader" style={{display: 'block', backgroundColor: 'rgba(91, 140, 184, 0.24)', overflow: 'auto'}} tabIndex="-1" role="dialog" aria-hidden="true">
                    <div class="modal-dialog modal-lg" role="document">
                        <div class="modal-content" style={{width: '137%', marginLeft: '-120px'}}>
                        <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLongTitle">Detail Pengerjaan Homework Siswa ({this.state.judulHw})</h5>
                            <span aria-hidden="true"></span>
                        </div>
                        <div class="modal-body">
                            {this.renderKelasParalel()}
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-primary" onClick={(e) => this.setState({openModalDetail : false})}>Ok</button>
                        </div>
                        </div>
                    </div>
                </div>
            );
        }
    }

    render() {
        return (
            <div className="wrapper">
                <LoaderModal isFetching={this.state.isFetching} />
                <Sidebar account={this.props.account}/>
                <div id="content" style={{paddingBottom: '50px'}}>
                    <Navbar />
                    <br></br>
                    {this.loading()}
                    {this.renderParent()}
                    <br></br>
                    {this.loading()}
                    {this.renderModalDetail()}
                </div>
            </div>
        )
    }

    
    loading = () =>{
        if(this.state.loading){
            return(
                <Loader />
            )
        }
    }
}
const mapStateToProps = (state) => {
    return {
        account: state.account
    };
}

export default connect(mapStateToProps, {cekCookies})(AktivitasHw)
